import { useMutation } from '@tanstack/react-query';

import { unwrap } from '@/api/envelope';
import {
  previewArc,
  type ArcDraftUpdate,
  type ArcPreviewResponse,
} from '@/api/generated';

/**
 * Preview's request (organization-arc, group 7; D16): the working copy, in
 * the body Save Draft takes, answered in the app's shape and kept nowhere.
 * A mutation rather than a query, because each press of Preview sends the
 * copy as it stands then, and nothing is cached. Staff viewing the
 * organization may send it: it changes nothing (`src/api/client.ts`).
 */
export function useArcPreview() {
  return useMutation({
    mutationFn: async (body: ArcDraftUpdate): Promise<ArcPreviewResponse> => {
      const reply = await previewArc({ body, throwOnError: true });
      return unwrap(reply.data);
    },
  });
}
